import { GoogleMap, withGoogleMap, withScriptjs } from "react-google-maps"
import * as React from 'react';
import { compose, withProps } from "recompose";
import Marker from 'react-google-maps/lib/components/Marker';
import { Dot } from './routeSelector';
import { DriverStateDTO } from '../api/model';
import InfoBox from 'react-google-maps/lib/components/addons/InfoBox';

import Button from '@material-ui/core/Button';
import LocalIcon from '../assets/imgs/cheese.png';
import { Link } from "react-router-dom";
import { ConfigData } from "../config";


const getColor = (data: any): string => {
    if(data.visitDate && data.visitDate !== '' && data.visited){
        return 'green';
    }
    if(!data.visitDate && data.visited === false){
        return 'grey'
    }

    return 'purple';
};

interface MarkerOfDriverWithInfoProps {
    data: any;
    open: boolean;
    toggle: () => void;
}

const MarkerOfDriverWithInfo: React.SFC<MarkerOfDriverWithInfoProps> = (props: MarkerOfDriverWithInfoProps) => {
    const color = getColor(props.data);
    return <Marker
        icon={{
            url: `http://maps.google.com/mapfiles/ms/icons/${color}-dot.png`,
            strokeColor: color,
            scale: 3
        }}
        onClick={props.toggle}
        position={props.data}>
        {props.open && <InfoBox
            onCloseClick={props.toggle}
            options={{ closeBoxURL: ``, enableEventPropagation: true }}
        >
            <div style={{ backgroundColor: 'black', padding: 12, width: 300 }}>
                <div style={{ color: `white` }}>
                    <table>
                        <tbody>
                            <tr>
                                <td>Nombre de conductor:</td>
                                <td>{props.data && props.data.driver.user && props.data.driver.user.name ? props.data.driver.user.name : 'Sin nombre'}</td>
                            </tr>
                            <tr>
                                <td>Estado:</td>
                                <td>{props.data.visitDate && props.data.visitDate !== '' && props.data.visited ? 'Visitado' : !props.data.visitDate && props.data.visited === false ? 'Cancelado' : 'Pendiente'}</td>
                            </tr>
                            <tr>
                                <td>Cliente:</td>
                                <td>{props.data && props.data.client && props.data.client.user.name ? props.data.client.user.name : 'Sin nombre'}</td>
                            </tr>
                            {props.data.raceState && <tr>
                                <td colSpan={2}>
                                    <Link to={"/race/" + props.data.lastRaceId}>
                                        <Button variant="contained" color="primary">Presione para más detalles</Button>
                                    </Link>
                                </td>
                            </tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        </InfoBox>}
    </Marker>
};

interface MapProps {

    zoom: number;
    center: Dot;
    data: DriverStateDTO[];
    predefinedFrom: boolean;

    handleOnClick(e: google.maps.MouseEvent | google.maps.IconMouseEvent): void;

}

class MapOfDrivers extends React.Component<MapProps, { open: { [K: number]: boolean } }> {

    constructor(props: MapProps) {
        super(props);
        this.state = {
            open: {}
        }
    }

    toggle = (info: DriverStateDTO) => {
        this.setState({
            open: {
                [info.id]: !this.state.open[info.id]
            }
        })
    };


    render() {

        const { center, zoom, data, handleOnClick } = this.props;
        return <div>
            <GoogleMap defaultZoom={zoom} center={center} onClick={handleOnClick}>
                {this.props.predefinedFrom && <Marker
                    position={this.props.center}
                    labelContent="Meet & Cheese"
                    icon={{
                        url: LocalIcon,
                        scale: 3
                    }}
                />}
                {data.map(ds =>
                    <MarkerOfDriverWithInfo key={ds.id}
                        data={ds}
                        open={this.state.open[ds.id]}
                        toggle={() => this.toggle(ds)} />
                )}
            </GoogleMap>
        </div>
    }
}

const EnhancedMap = compose<MapProps, MapProps>(
    withProps({
        containerElement: <div style={{ height: '400px' }} />,
        mapElement: <div style={{ height: '400px' }} />,
    }),
    withGoogleMap
)(MapOfDrivers);

interface DriverLocationProps {
    data: DriverStateDTO[],
    config: ConfigData;
}

const VisitsLocationComponent: React.SFC<DriverLocationProps> = (props: DriverLocationProps) => {

    return (
        <EnhancedMap
            center={props.config.maps.startingLocation}
            predefinedFrom={props.config.races.predefinedFrom}
            zoom={props.config.maps.startingLocation.zoom}
            data={props.data}
            handleOnClick={(dat) => {
                console.log(dat)
            }}
        >
        </EnhancedMap>
    );

};


export default compose<any, DriverLocationProps>(withProps((props: DriverLocationProps) => {
    return {
        googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${props.config.maps.key}`,
        loadingElement: <div style={{ height: '400px' }} />,
    }
}), withScriptjs)(VisitsLocationComponent);



// WEBPACK FOOTER //
// ./src/components/VisitsLocation.tsx